(function() {
    'use strict';
 
 
a3_pilot_reports.factory('ServerPilotReportFactory',ServerPilotReportFactory)

/* @ngInject */ 
function ServerPilotReportFactory(GenericService){
		// Define the constructor function.
		function ServerPilotReport() {
			this.AuthorAimsId = null;
			this.AuthorName = null;
			this.Created = null;
			this.FlightAimsId = null;
			this.FlightId=null;
			this.LastUpdated = null;
			this.ReportGuid = null;
			this.ReportId = null;
			this.ReportedItems = null;
			this.Source = null;// use ServerPilotReport.constSource* values
			this.getDescription = getDescription;
			this.isNothingToReport = isNothingToReport;
		}

		var objCallback = ServerPilotReport;
	
		function getDescription() {
			if (this.Created == null && this.AuthorName == null && this.ReportedItems == null) return '-null-';
			else return (this.AuthorAimsId || '?') + ' ' + (this.AuthorName || '?') + ' @ ' + (this.Created || '?') + (this.ReportedItems || 0) ==0 ? ' :: Nothing to report' : (this.ReportedItems || 0) + ' items logged';
		}
						
		function isNothingToReport(){
			return (this.ReportedItems || 0) == 0;
		}

		var service = {
			fromObjectList : fromObjectList,     
			constSourceLocalOwn  : 'localOwn', // stored locally by this user
			constSourceLocalOther  : 'localOther', // stored locally by another user
			constSourceStoredOwn  : 'storedOwn', // stored on the  server by this user
			constSourceStoredOther  : 'storedOther' // stored on the server by another user
		}

		function fromObjectList(objList) {
			return GenericService.fromObjectList(objList,objCallback);
		};
	
	return service;						  
	}

 })();   